import { render, staticRenderFns } from "./cashGiftHandle.vue?vue&type=template&id=b653b9dc&scoped=true"
import script from "./cashGiftHandle.vue?vue&type=script&lang=js"
export * from "./cashGiftHandle.vue?vue&type=script&lang=js"
import style0 from "./cashGiftHandle.vue?vue&type=style&index=0&id=b653b9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653b9dc",
  null
  
)

export default component.exports